import { useLazyQuery } from '@apollo/client'
import { GetClearanceStatus, GetClearanceStatusVariables } from '../../types'
import { GET_CLEARANCE_STATUS } from './operations'

interface Props {
  onCompleted?: () => void
}

export const useDownloadClearanceStatus = ({ onCompleted }: Props) =>
  useLazyQuery<GetClearanceStatus, GetClearanceStatusVariables>(GET_CLEARANCE_STATUS, {
    onCompleted,
  })
